/**
 * This is the main entry point of the Javascript.
 * It initializes the necessary components.
 */

// import { setCookie, getCookie } from "./components/cookies";
import Links from "./components/Links";
// import Sliders from "./components/Sliders";

document.addEventListener("DOMContentLoaded", () => {
    Links();
    
    const burgerWrapper = document.querySelector(".burger-menu");
    const burgerClose = document.querySelector(".burger-menu__close");
    const burgerLines = document.querySelector(".burger-js");
    const header = document.querySelector(".header");
    const residentsToolsItems = document.querySelectorAll('.residents-tools__wrapper-content-left-items-item');

    if (residentsToolsItems.length) {
        const firstContent = residentsToolsItems[0].querySelector('.residents-tools__wrapper-content-left-items-item-box-text');

        residentsToolsItems[0].classList.add('open');
        firstContent.style.height = firstContent.scrollHeight + 'px';

        residentsToolsItems.forEach(item => {
            item.addEventListener('click', () => {
                residentsToolsItems.forEach(el => {
                    const content = el.querySelector('.residents-tools__wrapper-content-left-items-item-box-text');

                    if (el === item) {
                        if (el.classList.contains('open')) {
                            el.classList.remove('open');
                            content.style.height = '0px';
                        } else {
                            el.classList.add('open');
                            content.style.height = content.scrollHeight + 'px';
                        }
                    } else {
                        el.classList.remove('open');
                        content.style.height = '0px';
                    }
                });
            });
        });
    }

    if (burgerLines) {
        burgerLines.addEventListener("click", function () {
            if (burgerWrapper) {
                burgerWrapper.classList.add("active");
            }
        });
    }

    if (burgerClose) {
        burgerClose.addEventListener("click", function () {
            if (burgerWrapper) {
                burgerWrapper.classList.remove("active");
            }
        });
    }

    if (burgerWrapper) {
        burgerWrapper.addEventListener("click", function (e) {
            if (e.target === burgerWrapper) {
                burgerWrapper.classList.remove("active");
            }
        });
    }

    if (header) {
        const toggleFixed = () => {
            header.classList.toggle("fixed", window.scrollY > 0);
        };

        toggleFixed();
        window.addEventListener("scroll", toggleFixed);
    }

});
